import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { from, Observable } from "rxjs";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return from(this.handleAccess(request, next));
  }

  private async handleAccess(request: HttpRequest<any>, next: HttpHandler): Promise<HttpEvent<any>> {
    // Only add to known domain(s)
    if (request.urlWithParams.indexOf("childrenshospitals.org/websvc") > -1) {
      request = request.clone({
        setHeaders: {
          Authorization: "X-API-KEY " + process.env.WEBSVCAPIKEY
        }
      });
    }
    return next.handle(request).toPromise();
  }
}
